export const DEFAULT_SEO = {
  siteName: 'Tradel',
  siteUrl: 'https://app.tradel.com.au',
  title: 'Trade delivery, done right.',
  titleWithSite: 'Tradel | Trade delivery, done right.',
  description:
    'Tradel is an Australian-owned, on-demand delivery platform built for trade, construction, and retail.',
  imagePath: '/logo.png',
  robotsNoIndex: 'noindex, nofollow, noarchive',
};

const unsafeSeoTextPattern =
  /(?:\b\d{3}\s*[-:]\s*|\binternal server error\b|\bapplication error\b|\bnuxt\b)/i;

export function normalizeSeoText(value: unknown, fallback = '') {
  const text =
    typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';

  if (!text || unsafeSeoTextPattern.test(text)) {
    return fallback;
  }

  return text;
}

export function normalizeSeoBaseURL(
  value: unknown,
  fallback = DEFAULT_SEO.siteUrl
) {
  const baseURL = typeof value === 'string' ? value.trim() : '';

  if (!baseURL) {
    return fallback;
  }

  return baseURL.replace(/\/+$/, '');
}

export function getAbsoluteSeoUrl(path: string, baseURL?: unknown) {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizeSeoBaseURL(baseURL)}${normalizedPath}`;
}

export function formatSeoTitle(
  title: unknown,
  siteName = DEFAULT_SEO.siteName
) {
  const safeSiteName = normalizeSeoText(siteName, DEFAULT_SEO.siteName);
  const safeTitle = normalizeSeoText(title, DEFAULT_SEO.title);

  if (
    safeTitle === safeSiteName ||
    safeTitle.startsWith(`${safeSiteName} |`) ||
    safeTitle.includes(`| ${safeSiteName}`)
  ) {
    return safeTitle;
  }

  return `${safeTitle} | ${safeSiteName}`;
}
